document.addEventListener("DOMContentLoaded", () => {
  const scripts = document.querySelectorAll('#swiper-script');
  scripts.forEach((script) => {
    const sectionID = script.getAttribute('data-sectionId');
    const paginationStyle = script.getAttribute('data-paginationStyle');
    const autoPlay = script.getAttribute('data-auto-rotate') === "true";
    const slidesToShow = Number(script.getAttribute('data-no-of-slides-desktop'));
    const noOfSlides = slidesToShow ? slidesToShow : 1;
    const slidesToShowtablet = Number(script.getAttribute('data-no-of-slides-tablet'));
    const noOfSlidesTablet = slidesToShowtablet ? slidesToShowtablet : 1;
    const slidesToShowMobile = Number(script.getAttribute('data-no-of-slides-tablet'));
    const noOfSlidesMobile = slidesToShowMobile ? slidesToShowMobile : 1;

    var paginationType;
    switch (paginationStyle) {
      case 'dots':
        paginationType = 'bullets';
        break;
      case 'counter':
        paginationType = 'fraction';
        break;
      case 'number':
        paginationType = 'fraction';
        break;
      default:
        paginationType = 'bullets';
        break;
    }

    var swiperOptions = {
      breakpoints: {
        640: {
          slidesPerView: noOfSlidesMobile,
        },
        768: {
          slidesPerView: noOfSlidesTablet,
        },
        1024: {
          slidesPerView: noOfSlides,
        },
      },
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: paginationType
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    };

    if (autoPlay) {
      swiperOptions.autoPlay = {
        delay: 2500,
        disableOnInteraction: false
      };
    }

    var swiper = new Swiper(`#${sectionID}`, swiperOptions);
  });
});